export default "__VITE_ASSET__4EEQWGfK__"